/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BadRequestResponse,
  ForbiddenResponse,
  InternalServerErrorResponse,
  NotFoundResponse,
  SearchOrganization200,
  SearchOrganizationParams,
  UnauthorizedResponse
} from '../model';

import { customInstance } from '../../custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Search for cases and documents within an organization
 */
export const searchOrganization = (
    organizationId: string,
    params: SearchOrganizationParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SearchOrganization200>(
      {url: `/organizations/${organizationId}/search`, method: 'GET',
        params, signal
    },
      options);
    }




export const getSearchOrganizationQueryKey = (organizationId: string,
    params?: SearchOrganizationParams,) => {
    return [
    `/organizations/${organizationId}/search`, ...(params ? [params] : [])
    ] as const;
    }


export const getSearchOrganizationQueryOptions = <TData = Awaited<ReturnType<typeof searchOrganization>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string,
    params: SearchOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchOrganization>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchOrganizationQueryKey(organizationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchOrganization>>> = ({ signal }) => searchOrganization(organizationId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchOrganization>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchOrganizationQueryResult = NonNullable<Awaited<ReturnType<typeof searchOrganization>>>
export type SearchOrganizationQueryError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse


export function useSearchOrganization<TData = Awaited<ReturnType<typeof searchOrganization>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    params: SearchOrganizationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchOrganization>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchOrganization>>,
          TError,
          Awaited<ReturnType<typeof searchOrganization>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchOrganization<TData = Awaited<ReturnType<typeof searchOrganization>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    params: SearchOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchOrganization>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchOrganization>>,
          TError,
          Awaited<ReturnType<typeof searchOrganization>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchOrganization<TData = Awaited<ReturnType<typeof searchOrganization>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    params: SearchOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchOrganization>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Search for cases and documents within an organization
 */

export function useSearchOrganization<TData = Awaited<ReturnType<typeof searchOrganization>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    params: SearchOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchOrganization>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchOrganizationQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






